/**
 * 应用题
 */
import QuestionStep from './view';
import './index.less';

export default QuestionStep;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/step/index.js